export const INITIAL_MAP_CONFIG = {
  lng: 105.85, // Default map center longitude (Vietnam)
  lat: 21.02, // Default map center latitude (Vietnam)
  zoom: 6, // Default zoom retaining multi-province framing
} as const;

/** Ward tracking map: minimum zoom when flying to a user selected from the list. */
export const WARD_MAP_SELECT_FLY_ZOOM = 13;

/** Ward tracking map: flyTo animation duration (ms) when selecting from the list. */
export const WARD_MAP_SELECT_FLY_DURATION_MS = 1100;

export const ADMIN_MAP_MAX_ZOOM = 7.5; // Central admin statistic variant — avoids street-detail zoom

export const ADMIN_MAP_MIN_ZOOM = 3.3; // Allows continent-scale overview on pinch-out

export const ADMIN_MAP_INITIAL_ZOOM = 5.15; // First paint zoom balancing landmass readability

export const MAP_CENTRAL_ADMIN_GROUP_ID = 1; // userProfile.groupid routing to AdminMap vs WardMap

export const MAP_PROVINCE_GROUP_ID = 3; // Provincial map - bubble statistic by province, center map by province_id of the user

export const PROVINCE_MAP_INITIAL_ZOOM = 9.5; //Default zoom when opening the provincial map - enough to see the distribution of the commune.

export const PROVINCE_MAP_MAX_ZOOM = 14; //Maximum zoom limit for the provincial map

export const STATISTIC_CIRCLE_RADIUS_BY_TOTAL_STOPS = [
  [0, 15],
  [120, 15.5],
  [320, 16],
  [2200, 16.75],
  [12000, 17.25],
  [52000, 17.5],
] as const satisfies ReadonlyArray<readonly [number, number]>;

/** Layer GeoJSON được xử lý click popup (MapBox.queryRenderedFeatures). */
export const STATISTIC_CIRCLE_LAYER_ID = 'vn-statistic-circle';

export const STATISTIC_FONT_PX_GTE_CHARS = {
  FALLBACK: 12,
  GTE_DIGITS_4: 10,
  GTE_DIGITS_6: 9,
  GTE_DIGITS_8: 8,
} as const;

/** Mapbox stroke width for statistic halo circle outline (pixels). */
export const STATISTIC_BUBBLE_BORDER_WIDTH_PX = 2; // White stroke outlining circle symbols

export const MARKER_POPUP_OFFSET: [number, number] = [-35, -47]; // The offset of the popup relative to the marker's position

/** Approximate rendered height of UserDetailPopup card (px), used for flyTo centering. */
export const USER_DETAIL_POPUP_HEIGHT_PX = 302;

/** flyTo screen offset so UserDetailPopup card center (not marker icon) sits at viewport center. */
export function getWardMapUserFlyToOffset(): [number, number] {
  const [popupOffsetX, popupOffsetY] = MARKER_POPUP_OFFSET;
  return [-popupOffsetX, -popupOffsetY + USER_DETAIL_POPUP_HEIGHT_PX / 2];
}

export const CIRCLE_STEPS = 64; // The number of segments (sides) needed to draw a circle

export const EARTH_RADIUS_METERS = 6378137; // Earth's equatorial radius in meters according to the WGS84 geodetic standard.

export const API_DEFAULT_PARAMS = {
  pageIndex: 1,
  pageSize: 500, // Pagination window large enough for map dataset pulls
} as const;
